import { testIgnoreDiacritics } from "@quortex/front-common"
import type { OttEndpointRow } from "@/App/play/App/Main/Pool/endpoints/ottEndpoints/OttEndpointList/types"

export const filterOttEndpointsBySearch = (rows: OttEndpointRow[], regexps: RegExp[]) =>
  rows
    .map(row => ({
      ...row,
      endpoints: row.endpoints.filter(endpoint =>
        regexps.every(
          regExp =>
            testIgnoreDiacritics(regExp, endpoint.processing?.name) ||
            testIgnoreDiacritics(regExp, endpoint.target?.name) ||
            testIgnoreDiacritics(regExp, endpoint.status) ||
            testIgnoreDiacritics(regExp, `/${endpoint.customPath}`) ||
            testIgnoreDiacritics(regExp, `/${endpoint.pretty}`)
        )
      )
    }))
    .filter(row => (regexps.length > 0 ? row.endpoints.length > 0 : true))
